import React from "react";
import Desk from "./Desk";
import { Configure, Sources, Review } from "./Configure";
import { Conditions, Resources, Cash, Routes, Commitments, Notices, Approval } from "./ReconcileResolve";
import { Evidence, Examination, Packet, Correction } from "./Deliver";
import { Flex } from "./Flex";
import { RecordScreen } from "./RecordScreen";
import { Plan } from "./Plan";
import { Handover, Reuse, Economics, Continuity, Transition, Recovery, Value, Rights, Remaining, Lifetime } from "./Handover";

import { Participants } from "./Workbench";
import Build from "./Build";
import Numbers from "./Numbers";
import Agreements from "./Agreements";
export const SCREENS: Record<string, React.ComponentType> = {
  build: Build, people: Participants, numbers: Numbers, agreements: Agreements,
  desk: Desk, configure: Configure, sources: Sources, review: Review, conditions: Conditions, resources: Resources, cash: Cash, routes: Routes, commitments: Commitments,
  notices: Notices, approval: Approval, evidence: Evidence, examination: Examination, packet: Packet, correction: Correction, handover: Handover, reuse: Reuse,
  economics: Economics, continuity: Continuity, transition: Transition, recovery: Recovery, value: Value, rights: Rights, remaining: Remaining, lifetime: Lifetime, flex: Flex, record: RecordScreen, plan: Plan,
};
